import React from 'react';
import { Switch } from 'react-router-dom';
import AxiosDataWrapper
  from '@avtechsoftware/react-component-library/src/components/common/AxiosDataWrapper/AxiosDataWrapper';
import AxiosDataIsLoaded
  from '@avtechsoftware/react-component-library/src/components/common/AxiosDataWrapper/AxiosDataIsLoaded/AxiosDataIsLoaded';
import MetricsPage from '../MetricsPage/MetricsPage';
import GuidancePage from '../GuidancePage/GuidancePage';
import SensorCapacityPage from '../SensorCapacityPage/SensorCapacityPage';
import HasRolePrivileges from '../../../highorder/HasRolePrivileges';
import { RaaRoles } from '../../../../utility/SecurityRules';
import RedirectToGatewayPage from '../RedirectToGatewayPage/RedirectToGatewayPage';
import AlertsPage from '../AlertsPage/AlertsPage';
import SmsBalancePage from '../../../sms/SmsBalancePage/SmsBalancePage';
import OrdersPage from '../OrdersPage/OrdersPage';
import OrderDetailsPage from '../../../orders/OrderDetailsPage/OrderDetailsPage';
import QuoteDetailsPage from '../../../quotes/QuoteDetailsPage/QuoteDetailsPage';
import ReferralsPage from '../ReferralsPage/ReferralsPage';
import ProtectedReferralsRoute from '../ReferralsPage/ProtectedReferralsRoute/ProtectedReferralsRoute';
import DevicesPage from '../../../devices/DevicesPage/DevicesPage';
import ActionsPage from '../ActionsPage/ActionsPage';
import SetupPage from '../../../setup/SetupPage/SetupPage';
import BillingRoutes from '../../../billing/BillingRoutes';
import RaaRoute from '../../../common/RaaRoute';
import SubscriptionNavTabs from '../../../sms/SubscriptionNavTabs/SubscriptionNavTabs';
import SetupChecklist from '../../../setup/SetupPage/SetupChecklist/SetupChecklist';
import WelcomePage from '../WelcomePage/WelcomePage';
import DashboardPage from '../../../dashboard/DashboardPage';

function AppPage() {
  /* istanbul ignore next */
  return (
    <Switch>
      <RaaRoute path="/s/dashboard">
        <DashboardPage />
      </RaaRoute>
      <RaaRoute path="/s/welcome">
        <WelcomePage />
      </RaaRoute>
      <RaaRoute path="/s/devices">
        <DevicesPage />
      </RaaRoute>
      <RaaRoute path="/s/sensor-data">
        <HasRolePrivileges
          targetRoleList={[RaaRoles.ADMIN, RaaRoles.MANAGER, RaaRoles.VIEWER]}
          alternativeComponent={<RedirectToGatewayPage />}
        >
          <MetricsPage />
        </HasRolePrivileges>
      </RaaRoute>
      <RaaRoute path="/s/guidance">
        <HasRolePrivileges
          targetRoleList={[RaaRoles.ADMIN, RaaRoles.MANAGER, RaaRoles.VIEWER]}
          alternativeComponent={<RedirectToGatewayPage />}
        >
          <GuidancePage />
        </HasRolePrivileges>
      </RaaRoute>
      <RaaRoute path="/s/sensor-capacity">
        <HasRolePrivileges
          targetRoleList={[RaaRoles.ADMIN, RaaRoles.MANAGER]}
          alternativeComponent={<RedirectToGatewayPage />}
        >
          <SensorCapacityPage />
        </HasRolePrivileges>
      </RaaRoute>
      <RaaRoute path="/s/alerts">
        <HasRolePrivileges
          targetRoleList={[RaaRoles.ADMIN, RaaRoles.MANAGER, RaaRoles.VIEWER]}
          alternativeComponent={<RedirectToGatewayPage />}
        >
          <AlertsPage />
        </HasRolePrivileges>
      </RaaRoute>
      <RaaRoute path="/s/actions">
        <HasRolePrivileges
          targetRoleList={[RaaRoles.ADMIN, RaaRoles.MANAGER, RaaRoles.VIEWER]}
          alternativeComponent={<RedirectToGatewayPage />}
        >
          <ActionsPage />
        </HasRolePrivileges>
      </RaaRoute>
      <RaaRoute path="/s/user/referrals">
        <ProtectedReferralsRoute>
          <AxiosDataWrapper
            url="/order/country-list"
            config={{ dataTitle: 'countryList' }}
          >
            <AxiosDataIsLoaded>
              <ReferralsPage />
            </AxiosDataIsLoaded>
          </AxiosDataWrapper>
        </ProtectedReferralsRoute>
      </RaaRoute>
      <RaaRoute path="/s/subscription/billing" minimumTierLevel={0}>
        <HasRolePrivileges
          targetRoleList={[RaaRoles.ADMIN, RaaRoles.MANAGER, RaaRoles.BILLING]}
          alternativeComponent={<RedirectToGatewayPage />}
        >
          <BillingRoutes />
        </HasRolePrivileges>
      </RaaRoute>
      <RaaRoute path="/s/subscription/sms">
        <HasRolePrivileges
          targetRoleList={[RaaRoles.ADMIN, RaaRoles.MANAGER, RaaRoles.BILLING]}
          alternativeComponent={<RedirectToGatewayPage />}
        >
          <SmsBalancePage />
        </HasRolePrivileges>
      </RaaRoute>
      <RaaRoute path="/s/subscription/setup-checklist">
        <>
          <SubscriptionNavTabs activeKey="/s/subscription/setup-checklist" />
          <SetupChecklist />
        </>
      </RaaRoute>
      <RaaRoute path="/s/orders" minimumTierLevel={0}>
        <OrdersPage />
      </RaaRoute>
      <RaaRoute path="/s/order/details/:id" exact minimumTierLevel={0}>
        <OrderDetailsPage />
      </RaaRoute>
      <RaaRoute path="/s/quotes/details/:id" exact minimumTierLevel={0}>
        <QuoteDetailsPage />
      </RaaRoute>
      <RaaRoute path="/s/setup">
        <SetupPage />
      </RaaRoute>
    </Switch>
  );
}

export default AppPage;
